export default __webpack_public_path__ + "static/media/manage-bmj-reward-points.084be387.svg";